import ContentLoader from "react-content-loader";

const TracksLoader = (props) => (
  <ContentLoader
    width={515}
    height={37}
    speed={2}
    viewBox="0 0 515 37"
    {...props}
  >
    <rect
      className="cls-1"
      x=".11"
      y=".11"
      width="515"
      height="26.34"
      rx="6.55"
      ry="6.55"
    />
  </ContentLoader>
);

export default TracksLoader;
